export const UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST = "UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST";
export const UPDATE_REMITTANCE_PAYOUT_CYCLE_SUCCESS = "UPDATE_REMITTANCE_PAYOUT_CYCLE_SUCCESS";
export const UPDATE_REMITTANCE_PAYOUT_CYCLE_FAILURE = "UPDATE_REMITTANCE_PAYOUT_CYCLE_FAILURE";
export const UPDATE_REMITTANCE_PAYOUT_CYCLE_RESET = "UPDATE_REMITTANCE_PAYOUT_CYCLE_RESET";
export const updateRemittancePayoutCycleRequest = (payload) => ({
    type: UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST,
    payload,
});
export const updateRemittancePayoutCycleSuccess = (payload) => ({
    type: UPDATE_REMITTANCE_PAYOUT_CYCLE_SUCCESS,
    payload,
});
export const updateRemittancePayoutCycleFailure = (payload) => ({
    type: UPDATE_REMITTANCE_PAYOUT_CYCLE_FAILURE,
    payload,
});
export const updateRemittancePayoutCycleReset = () => ({
    type: UPDATE_REMITTANCE_PAYOUT_CYCLE_RESET,
});
